import { render, staticRenderFns } from "./mediaFileStory.vue?vue&type=template&id=b00d4208&"
import script from "./mediaFileStory.vue?vue&type=script&lang=js&"
export * from "./mediaFileStory.vue?vue&type=script&lang=js&"
import style0 from "./mediaFileStory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VIcon,VImg})
